import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_SECRET_KEY;

export const encryptItem = (data) => {
  let storedData = {};
  if (localStorage.getItem("userData")) {
    const encryptedData = localStorage.getItem("userData");
    storedData = decryptItem(encryptedData);
  }

  const updatedData = { ...storedData, ...data };

  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(updatedData),
    secretKey
  ).toString();

  localStorage.setItem("userData", encryptedData);
};

export const decryptItem = () => {
  let encryptedData = localStorage.getItem("userData");
  let decryptedData;
  if (encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  }
  return encryptedData ? JSON.parse(decryptedData) : {};
};
